<template>
  <div class="login text-center">
    <div class="container-md d-flex flex-row-reverse">
      <div class="login-content text-center">

        <div class="top-tools">
          <span class="lang-btn" v-if="$i18n.locale == 'en'" @click="onChangeLang()">中文</span>
          <span class="lang-btn" v-else @click="onChangeLang()">ENG</span>
        </div>

        <div class="login-content-box px-4 py-5 col-7 me-auto ms-auto mt-5 text-start rounded-3">
          <div class="mb-3 py-1">
            <h3>{{ $t('login.title3') }}</h3>
          </div>
          <div class="mb-3">
            <label
              for="inputEmail4"
              class="form-label"
            >{{ $t('login.email') }}</label>
            <input
              id="inputEmail4"
              v-model="form.email"
              type="email"
              :class="['form-control', emailDanger]"
              placeholder=""
            >
          </div>
          <div class="mb-3">
            <label
              for="inputPassword4"
              class="form-label"
            >{{ $t('login.new')+$t('login.password')}}</label>
            <input
              id="inputPassword4"
              v-model="form.password"
              type="password"
              :class="['form-control', passwordDanger]"
              placeholder=""
            >
          </div>
          <div class="mb-3">
            <label
              for="inputPassword4"
              class="form-label"
            >{{ $t('login.password2') }}</label>
            <input
              id="inputPassword4"
              v-model="form.password2"
              type="password"
              :class="['form-control', passwordDanger]"
              placeholder=""
            >
          </div>
          <div class="mb-3">
            <label
              for="inputCode4"
              class="form-label"
            >{{ $t('login.verifycode') }}</label>
            <div class="input-group">
              <input
                v-model="form.code"
                type="text"
                :class="['form-control', codeDanger]"
              >
              <button
                class="btn btn-outline-secondary"
                type="button"
                @click="sendCode"
              >
                <span v-if="sendCodeTime">
                  {{ $t('login.already') }}{{ $t('login.getverifycode') }}({{ sendCodeTime }})
                </span>
                <span v-else>
                  {{ $t('login.getverifycode') }}
                </span>
              </button>
            </div>
          </div>
          <div class="mb-2 user-select-none">
            <button
              type="button"
              class="btn btn-success w-100"
              @click="reset"
            >
              {{ $t('login.reset') }}
            </button>
          </div>
          <div class="mb-1 user-select-none d-flex">
            <div class="form-check flex-fill">
              <input
                id="iAccept"
                v-model="iaccept"
                :checked="iaccept"
                :class="['form-check-input', acceptDanger]"
                type="checkbox"
              >
              <label
                class="form-check-label"
                for="iAccept"
              >
                {{ $t('login.iaccept') }}<span class="ms-2"><u @click="modalShowFun">{{ $t('login.disclaimer') }}</u></span>
              </label>
            </div>
            <div class="mb-1 user-select-none form-link">
              <u @click="login">{{ $t('login.loginnow') }}</u>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="modalShow"
      class="modal"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-fullscreen-md-down">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('login.disclaimer') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="modalHideFun"
            />
          </div>
          <div class="modal-body">
            <div class="content">

<h2>BnBVet operates the bnbvet.com website, which provides the SERVICE.</h2><p>This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the Website name website.</p><p>If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.</p><p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at bnbvet.com, unless otherwise defined in this Privacy Policy.</p><h2>Information Collection and Use</h2><p>For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you without your consent.</p><h2>Log Data</h2><p>We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.</p><h2>Cookies</h2><p>Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.</p><p>Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.</p><p>For more general information on cookies, please read&nbsp;"What Are Cookies".</p><h2>Service Providers</h2><p>We may employ third-party companies and individuals due to the following reasons:</p><p>· To facilitate our Service;</p><p>· To provide the Service on our behalf;</p><p>· To perform Service-related services;</p><p>· To assist us in analyzing how our Service is used.</p><p>We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p><h2>Security</h2><p>We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p><h2>Links to Other Sites</h2><p>Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p><h2>Changes to This Privacy Policy</h2><p>We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.</p><h2>Contact Us</h2><p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.</p><h2>General</h2><p>https://www.bnbvet.com/ and other related IOS and Android applications (collectively, the “Platform”) is operated by BnBVet INTERNATIONAL LIMITED (“BnBVet”), a company incorporated under the laws of the Hong Kong Special Administrative Region.</p><p>By accessing and/or using the Platform, you acknowledge and understand that BnBVet is not a veterinary medical provider and that BnBVet does not provide any healthcare services through the operation of the Platform.  Instead, BnBVet operates the Platform solely to facilitate the provision of healthcare services by veterinary medical providers to you and your pet(s) via scheduled online consultations, and no professional relationship is intended to be created between BnBVet and you whatsoever.  </p><p>The content of the Platform (the “Content”) is for general information purposes only and should not be considered as or substituted for professional veterinary care advice, diagnosis or treatment.  Any healthcare services provided by veterinary medical providers via the Platform are provided by them as independent contractors, and not employees, of BnBVet.  BnBVet assumes no responsibility and/or liability in relation to the reliability, completeness and accuracy of the information of the veterinary medical providers (including but not limited to their profiles, information and qualifications) as displayed on the Platform.</p><p>Online Consultations provided and/or arranged through the Platform (the “Online Consultations”) </p>
  <h2>Regulatory Disclaimer</h2>
  <p>Veterinarian is a regulated profession in many jurisdictions, yet the laws and regulations governing the provision of healthcare services by veterinary medical providers through any online platform are currently unclear. We made no representations that the provision of healthcare services or Online Consultation by veterinary medical provider through the Platform is or is not an activity regulated or governed by any regulatory bodies.  We do not make any representation or warranty that the provision of healthcare services or Online Consultations through the Platform is subject to regulatory oversight or approval.  By accessing and/or using the Platform, you are deemed to understand and accept such limitations and risks, and that it is unclear whether, by the provision of healthcare services or Online Consultation through the Platform, the veterinary medical provider is or is not in breach of any laws and/or regulations of any regulatory bodies.  </p>
  <p>Further, if you choose a veterinary medical provider for the provision of healthcare services or Online Consultation
  through the Platform who is located and/or licensed to practice in another jurisdiction, you are deemed to accept the
  risk and uncertainty that the regulatory body in your jurisdiction may not have the authority to accept, handle or hear
  any complaint from you against a veterinary service provider located and/or licensed to practice in other jurisdiction
  at the time when the services were carried out, and the regulatory body of the jurisdiction in which the veterinary
  service provider is located and/or licensed to practice may not have the authority to accept, handle or hear any
  complaint from you when you are located outside of the regulatory body’s jurisdiction at the time when the services were
  carried out. You further acknowledge and accept the risk that it is possible that insurance coverage (if any) for claims
  arising out of or derived from professional negligence in relation to the provision of healthcare services or Online
  Consultation by a veterinary medical provider through the Platform, regardless of where the veterinary medical provider
  is located and/or licensed to practice, may not be available. Insurance coverage (if any) may vary depending on the
  jurisdiction in which the veterinary medical provider is located and/or licensed to practice and the specific terms and
  conditions of their insurance policies.</p>
<h2>Associated limitations</h2><p>In accepting and undertaking the Online Consultations, you understand that there are associated limitations as to the evaluation and deduction of the condition of your pet(s) by the veterinary medical providers without a physical examination and there are potential risks to this form of consultation.  </p><p>While veterinary medical providers may provide real-time responses and support to you during the Online Consultations, you also acknowledge and understand that the Online Consultations are not intended for medical emergencies and you should seek appropriate veterinary medical care if you believe your pet is experiencing a medical emergency. It is your sole responsibility to contact your veterinary medical provider and/or to attend the clinic for in-person and/or emergency veterinary medical care should the condition of your pet(s) persists or deteriorates unexpectedly and/or require immediate medical attention.  BnBVet shall not be responsible and/or liable for any delayed diagnosis or treatment as a result of or in connection with the Online Consultations. </p><p>For the purpose of the Online Consultations or otherwise, BnBVet and the veterinary medical providers rely on the accuracy of information (including but not limited to the identity and past medical history of your pet(s)) provided by you. BnBVet offers no means of verification regarding such information and shall not be responsible for verifying any information provided by you.  </p><h2>Modification or cancellation of Online Consultation booking</h2><p>While you may make an appointment for Online Consultation according to the available timeslots as displayed on the Platform, such appointment may be changed, modified, or cancelled by BnBVet, subject to availability of the veterinary medical provider or other change in circumstances. BnBVet expressly disclaims any responsibility and/or liability arising from any change, modification or cancellation made to your booking. Please consult BnBVet separately for the Online Consultation booking modification or cancellation policy. </p><h2>Suggestions or recommendations given during the Online Consultations </h2><p>BnBVet does not represent or warrant that any suggestion or recommendation (including, but not limited to, health, behaviour or wellness suggestions or recommendations) referred to or described in the Content or otherwise provided by any veterinary medical provider during the Online Consultations will be safe, appropriate or effective for your pet(s).  BnBVet shall not assume any responsibility and/or liability arising from any communication (including but not limited to the suggestions or recommendations mentioned above) between you and veterinary medical providers before, during, or subsequent to the Online Consultation by any means, including but not limited to video-conferencing, emails, phone calls and instant messaging.  </p><h2>Prescription of medication and/or supplements </h2><p>Veterinary medical provider may, at his/her sole discretion in accordance with his/her medical expertise and knowledge of the animal patients’ conditions, prescribe medications (together with adequate instructions for proper administration of such medication) and/or supplements to the animal patients as he/she considers appropriate following the Online Consultation(s). BnBVet assumes no responsibility for any prescription of medication and/or supplements by any veterinary medical providers and accepts no responsibility for the use of any such medication and/or supplements as well as their suitability, effectiveness, availability and quality. </p><h2>Subsequent referrals </h2><p>While veterinary medical provider may refer you and your pet(s) for in-person consultation at any clinic he/she considers appropriate subsequent to the Online Consultation(s) for further diagnosis and treatment, any such referral is made solely at the discretion of the veterinary medical provider and any such in-person consultation is only arranged as among you, the veterinary medical provider and/or the clinic. BnBVet assumes no responsibility and/or liability for any such in-person consultation arranged and/or services provided by the veterinary medical provider and/or the clinic. </p><h2>Pricing</h2><p>BnBVet has the right to review and update the prices for Online Consultations as displayed on the Platform and such prices may be subject to changes at any time without further notice. </p><h2>Other Limitations </h2><p>You acknowledge that the Platform may be subject to disruption, interruption, unauthorized access and/or other technical or technological difficulties, and as such, a delay in medical evaluation or treatment could occur. BnBVet expressly disclaims any responsibility and/or liability arising from any disruption, interruption or delay in medical evaluation of treatment provided (including but not limited to, where applicable, diagnosis, treatment or prescriptions).</p><p>BnBVet also expressly disclaims any responsibility and/or liability with respect to your access to and/or use of any application or software (including but not limited to video-conferencing applications, payment platform and/or delivery services) in connection with the Online Consultations. </p><h2>Claims and liability </h2><p>BnBVet, its affiliates, and their respective directors, officers, shareholders, representatives, employees and/or agents shall not be liable to you nor shall you have any claim of any nature against any of them in respect of or arising out of or in connection to the access or use of the Platform and the Content, the provision of services via the Platform (including but not limited to the Online Consultations), or any interruption, disruption, cessation or inability to access or use of the Platform. </p><p>Persons who access and use the Platform and/or services do so at their own discretion and risk and shall be responsible for compliance with the applicable laws, rules and regulations of the relevant jurisdictions. </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  // eslint-disable-next-line
  name: 'user-reset-password',
  components: {

  },
  data() {
    return {
      modalShow: false,
      form: {
        user_name: '',
        email: '',
        phone: '',
        password: '',
        password2: '',
        code: '',
        register_type: 'EMAIL',
      },
      iaccept: true,
      sendCodeTime: 0,
      interval: '',
      confirmTime: 0,
      confirmInterval: '',
      emailDanger: '',
      phoneDanger: '',
      passwordDanger: '',
      codeDanger: '',
      acceptDanger: '',
    };
  },
  mounted() {
    // console.log(this.$data['emailDanger'])

  },
  beforeRouteEnter(to, from, next) {
    if (from.path != '/user/login'
        && from.path != '/user/signup'
        && from.path != '/user/reset/password'
        && from.path != '/'
    ) {
      localStorage.setItem('fromPage', from.path);
    }
    next();
  },
  methods: {
    onChangeLang() {
      // console.log(this.$i18n.locale);
      if (this.$i18n.locale == 'zh_TW') {
        this.$i18n.locale = 'en';
      } else {
        this.$i18n.locale = 'zh_TW';
      }
    },
    sendCode() {
      if (!this.checkEmail(this.form.email)) {
        this.setDanger('emailDanger');
        return;
      }
      if (!this.iaccept) {
        this.setDanger('acceptDanger');
        return;
      }
      if (this.sendCodeTime == 0) {
        this.$api.user.sendPasswordCode({ email: this.form.email }).then((res) => {
          if (res.data.code == 200) {
            this.$toast.show({ title: this.$t('tips'), content: this.$t('login.tipstext') });
          } else {
            this.$toast.show({ title: this.$t('tips'), content: res.data.msg });
          }
        });
        clearInterval(this.interval);
        this.sendCodeTime = 60;
        this.interval = setInterval((_) => {
          if (this.sendCodeTime) {
            this.sendCodeTime -= 1;
          } else {
            clearInterval(this.interval);
          }
        }, 1000);
      }
    },
    reset() {
      if (!this.checkEmail(this.form.email)) {
        this.setDanger('emailDanger');
        return;
      }
      if (!this.form.password || this.form.password != this.form.password2) {
        this.setDanger('passwordDanger');
        return;
      }
      if (!this.form.code) {
        this.setDanger('codeDanger');
        return;
      }
      if (!this.iaccept) {
        this.setDanger('acceptDanger');
        return;
      }

      if (this.confirmTime == 0) {
        this.form.user_name = this.form.email;
        this.$api.user.resetPassword({
          email: this.form.email, password: this.form.password, confirm_password: this.form.password2, code: this.form.code,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$store.dispatch('setUserInfo', res.data.data);
            this.$toast.show({ content: this.$t('login.reset') + this.$t('login.success') });
            setTimeout((_) => {
              this.jumpToPage();
            }, 1000);
          } else {
            this.$toast.show({ title: this.$t('tips'), content: res.data.msg });
          }
        });
        this.confirmTime = 3;
        this.confirmInterval = setInterval((_) => {
          if (this.confirmTime) {
            this.confirmTime -= 1;
          } else {
            clearInterval(this.confirmInterval);
          }
        }, 1000);
      }
    },
    jumpToPage() {
      let fromPage = localStorage.getItem('fromPage');
      if (fromPage) {
        this.$router.push(fromPage);
        localStorage.setItem('fromPage', '');
      } else {
        this.$router.push('/member/reserve');
      }
    },
    login() {
      this.$router.push('/user/login');
    },
    modalShowFun() {
      this.modalShow = true;
    },
    modalHideFun() {
      this.modalShow = false;
    },
    setDanger(dnger) {
      let count = 0; let
        i;
      i = setInterval((_) => {
        if (count < 16) {
          count += 1;
          this.$data[dnger] ? (this.$data[dnger] = '') : (this.$data[dnger] = 'border-danger');
        } else {
          clearInterval(i);
        }
      }, 200);
    },
  },
};
</script>
<style lang="scss" scoped>
.login{
  height: calc( 100vh - 60px );
  width: 100%;
  background-color: #F3F2ED;
  background-image: url("@/assets/pages/login-bg.png");
  background-repeat: no-repeat;
  background-size: auto 70%;
  background-position-x: 0px;
  background-position-y: 100%;
  position: relative;
  .login-content{
    height: calc( 100vh - 60px );
    width: 50%;
    background-color: #F3F2ED;
    position: relative;
    background-image: url("@/assets/pages/login-bg-2.png");
    background-repeat: no-repeat;
    background-size: auto 40%;
    background-position-x: 100%;
    background-position-y: 0px;
    .login-content-box{
      background-color: #ffffff;
    }
    .border-danger{
      box-shadow: 0 0 0 0.25rem rgba(255, 33, 33, 0.5);

    }
  }
  .modal{
    display: block;
  }
  .top-tools{
    // background-color: #EFEFEF;
    display: none;
    position: absolute;
    z-index: 2;
  }
}
@media (max-width: 767.98px) {
  .login{
    // background-size: 100% auto;
    .container-md{
      padding: 0px;
      .login-content{
        width: 100%;
        background-color: rgba(255,255,255,0.9);
        .login-content-box{
          background-color: rgba(255,255,255,0);
          width: 100%;
        }
      }
    }
    .top-tools{
      // background-color: #EFEFEF;
      display: block;
      width: 100%;
      height: 70px;
      text-align: right;
      padding: 10px 20px;
      .icon{
        font-size: 22px;
        margin-left: 10px;
      }
      .lang{
        vertical-align: top;
        margin-top: 4px;
      }

    }
  }
}
</style>
